import { getAssetUrl } from '../constants/storage';

// Types d'applications disponibles
export type AppType = 'Finance' | 'Shopping' | 'Transport' | 'Logement' | 'Service' | 'Social' | 'Autres';

// Définition du type pour les applications avec les propriétés supplémentaires
export type AppWithIcon = {
  id: number;
  name: string;
  name_en?: string | null;
  logo: string;
  banner: string;
  description: string;
  description_en?: string | null;
  show: boolean;
  is_business_app?: boolean;
  view?: 'main' | 'other';
  type?: AppType;
  created_at?: string;
  updated_at?: string;
};

// Fallback data pour les applications au cas où la requête échoue
export const FALLBACK_APPS: AppWithIcon[] = [
  {
    id: 1,
    name: 'Coffre',
    name_en: 'Vault',
    logo: getAssetUrl('myfiles/logos/EpargneLogoApp.png'),
    banner: getAssetUrl('Files/Banners/EparngeImagePresentation.jpeg'),
    description: 'Gérez votre économie intelligemment avec notre solution innovante.',
    description_en: 'Manage your savings smartly with our innovative solution.',
    show: true,
    view: 'main',
    type: 'Finance',
  },
  {
    id: 2,
    name: 'Burok JOB',
    name_en: 'Burok Jobs',
    logo: getAssetUrl('myfiles/PublicImages/BurokJoblogo.png'),
    banner: getAssetUrl('Files/Banners/2d2d4bce-ba1f-407c-b9eb-fecfb9f4e153.jpeg'),
    description: 'Trouvez des flex jobs adaptés à votre disponibilité et gagnez de l\'argent facilement.',
    description_en: 'Find flexible jobs that match your availability and earn money easily.',
    show: false,
    view: 'other',
    type: 'Autres',
  },
  {
    id: 3,
    name: 'Kiosk',
    name_en: 'Kiosk',
    logo: getAssetUrl('Files/Logos/Kiosk.gif'),
    banner: getAssetUrl('Files/Banners/Kiosk%20!!.png'),
    description: 'Votre point de vente digital tout-en-un.',
    description_en: 'Your all-in-one digital point of sale.',
    show: true,
    view: 'main',
    type: 'Shopping',
  },
  {
    id: 4,
    name: 'Colis Express',
    name_en: 'Express Parcels',
    logo: getAssetUrl('Files/Logos/ColisApplogo.png'),
    banner: getAssetUrl('Files/Banners/ColiPresentation.jpeg'),
    description: 'Tu cherches un livreur ou GP ? Pas de probleme. Expédiez, suivez et recevez vos colis en toute simplicité.',
    description_en: 'Looking for a delivery driver or GP? No problem. Send, track, and receive your parcels with ease.',
    show: false,
    view: 'other',
    type: 'Service',
  },
  {
    id: 5,
    name: 'Services',
    name_en: 'My Services',
    logo: getAssetUrl('Files/Logos/Mes%20Services.gif'),
    banner: getAssetUrl('Files/Banners/Colorsss.jpeg'),
    description: 'Accédez à tous vos services essentiels en un seul endroit.',
    description_en: 'Access all your essential services in one place.',
    show: false,
    view: 'other',
    type: 'Service',
  },
  {
    id: 6,
    name: 'Events',
    name_en: 'Events',
    logo: getAssetUrl('Files/Logos/Events.gif'),
    banner: getAssetUrl('Files/Banners/Events.jpg'),
    description: 'Découvrez et participez aux meilleurs événements.',
    description_en: 'Discover and attend the best events around you.',
    show: false,
    view: 'other',
    type: 'Social',
  },
  {
    id: 7,
    name: 'Mes points',
    name_en: 'My Points',
    logo: getAssetUrl('Files/Logos/LOGOBurokpoint.png'),
    banner: getAssetUrl('Files/Banners/PinImage1.jpeg'),
    description: 'Suivez et échangez vos points de fidélité.',
    description_en: 'Track and redeem your loyalty points.',
    show: true,
    view: 'other',
    type: 'Finance',
  },
  {
    id: 8,
    name: 'Burok Mobile',
    name_en: 'Burok Mobile',
    logo: getAssetUrl('Files/Logos/BurokMobileApp1.png'),
    banner: getAssetUrl('Files/Banners/bberber00417707.6661d2de110c02.jpg'),
    description: 'Connectez-vous en illimité avec nos eSIM performantes et économiques.',
    description_en: 'Stay connected without limits with our powerful and affordable eSIMs.',
    show: false,
    view: 'other',
    type: 'Service',
  },
  {
    id: 9,
    name: 'LIVE',
    name_en: 'LIVE',
    logo: getAssetUrl('Files/Logos/LIVEV2.png'),
    banner: getAssetUrl('Files/Banners/Dudu1.png'),
    description: 'Votre télévision sur mobile, regardez vos chaînes préférées où que vous soyez.',
    description_en: 'Your TV on mobile: watch your favorite channels wherever you are.',
    show: true,
    view: 'other',
    type: 'Autres',
  },
  {
    id: 10,
    name: 'Flash Cas',
    name_en: 'Flash News',
    logo: getAssetUrl('Files/Logos/Gusta.png'),
    banner: getAssetUrl('Files/Banners/Flashcas.jpeg'),
    description: 'Suivez l\'actualité en temps réel : ne ratez rien des nouvelles fraîches de Dakar et d\'ailleurs.',
    description_en: 'Follow the news in real time and never miss the latest stories from Dakar and beyond.',
    show: true,
    view: 'main',
    type: 'Social',
  },
  {
    id: 11,
    name: 'Talli',
    name_en: 'Talli',
    logo: getAssetUrl('Files/Logos/TALLISIMPLELOGO.png'),
    banner: getAssetUrl('Files/Banners/TalliBannerBurok.webp'),
    description: 'Achetez et gérez vos tickets de transport en toute simplicité.',
    description_en: 'Buy and manage your transport tickets with ease.',
    show: true,
    view: 'other',
    type: 'Transport',
  },
  {
    id: 12,
    name: 'Boutiques',
    name_en: 'Shops',
    logo: getAssetUrl('Files/Logos/BoutiquesAppLogo.png'),
    banner: getAssetUrl('Files/Banners/MaBoutique.jpg'),
    description: 'Commandez auprès des commerces à proximité et faites-vous livrer.',
    description_en: 'Order from nearby shops and get delivered to your door.',
    show: true,
    view: 'main',
    type: 'Shopping',
  },
  {
    id: 13,
    name: 'Restaurants',
    name_en: 'Restaurants',
    logo: getAssetUrl('Files/Logos/Restaurant.png'),
    banner: getAssetUrl('Files/Banners/Hamburger.jpeg'),
    description: 'Commandez vos plats préférés et faites-vous livrer à domicile.',
    description_en: 'Order your favorite meals and get them delivered to your home.',
    show: true,
    view: 'main',
    type: 'Shopping',
  },
  {
    id: 14,
    name: 'Tontine',
    name_en: 'Tontine Circles',
    logo: getAssetUrl('Files/Logos/TontineLogo.png'),
    banner: getAssetUrl('Files/Banners/TontineBanner.jpeg'),
    description: 'Gérez vos tontines en toute simplicité et sécurité.',
    description_en: 'Manage your tontines with simplicity and security.',
    show: false,
    view: 'other',
    type: 'Finance',
  },
  {
    id: 15,
    name: 'Roots.',
    name_en: 'Roots.',
    logo: getAssetUrl('Files/Logos/Roots..gif'),
    banner: getAssetUrl('Files/Banners/RootsPresent.png'),
    description: 'Accédez aux dernières actualités, articles et tendances médiatiques en un seul endroit.',
    description_en: 'Access the latest news, articles, and media trends all in one place.',
    show: false,
    view: 'other',
    type: 'Social',
  },
  {
    id: 16,
    name: 'LINK',
    name_en: 'LINK',
    logo: getAssetUrl('Files/Logos/LINKLOGOFFICIEL.gif'),
    banner: getAssetUrl('Files/Banners/cbc91ee86e94b375a360d36101ade469.jpg'),
    description: 'Connectez-vous avec votre communauté et partagez vos moments.',
    description_en: 'Connect with your community and share your moments.',
    show: true,
    view: 'main',
    type: 'Social',
  },
  {
    id: 17,
    name: 'Keurgui',
    name_en: 'Keurgui',
    logo: getAssetUrl('Files/Logos/KeurguiAppLogo.png'),
    banner: getAssetUrl('Files/Banners/Keurgui.jpeg'),
    description: 'Trouvez une maison, un appartement, un hôtel… tout est dans Keurgui !',
    description_en: 'Find a house, apartment, hotel… everything is in Keurgui!',
    show: false,
    view: 'other',
    type: 'Logement',
  },
  {
    id: 18,
    name: 'Mon Identité',
    name_en: 'My ID',
    logo: getAssetUrl('Files/Logos/IdDigi.png'),
    banner: getAssetUrl('Files/Banners/Idprof2.jpg'),
    description: 'Votre portefeuille d\'identité numérique sécurisé et 100% digital.',
    description_en: 'Your secure and 100% digital identity wallet.',
    show: true,
    view: 'main',
    type: 'Service',
  },
  {
    id: 33,
    name: 'TikiTak: Clips',
    name_en: 'TikiTak: Clips',
    logo: getAssetUrl('Files/Logos/Tikitak.png'),
    banner: getAssetUrl('Files/Banners/TikitakBanner.jpeg'),
    description: 'Gagnez de l\'argent en étant ambassadeur Burok',
    description_en: 'Earn money by becoming a Burok ambassador.',
    show: false,
    view: 'other',
    type: 'Social',
  },
  {
    id: 35,
    name: 'Money Mukbang',
    name_en: 'ShopLink',
    logo: getAssetUrl('Files/Logos/SalaireAppLogo.png'),
    banner: getAssetUrl('Files/PublicImages/ice%20cream%20girls.jpg'),
    description: 'Burok verse un salaire offert à tous ses utilisateurs, récupérez-le tous les mois.',
    description_en: 'Burok pays a free salary to all its users—claim it every month.',
    show: false,
    view: 'other',
    type: 'Autres',
  },
  {
    id: 36,
    name: 'Cocorico App',
    name_en: 'Propulse',
    logo: getAssetUrl('Files/Logos/Cocorico%20App.png'),
    banner: getAssetUrl('Files/Banners/Cocorico%20banner.png'),
    description: 'Découvrez une nouvelle expérience avec Cocorico App.',
    description_en: 'Discover a brand new experience with the Cocorico app.',
    show: false,
    view: 'other',
    type: 'Autres',
  },
  {
    id: 38,
    name: 'Paylink',
    name_en: 'Paylink',
    logo: getAssetUrl('Files/Logos/Paylink%20Logo%20App.png'),
    banner: getAssetUrl('Files/PublicImages/PAYLINK%20Banner.png'),
    description: 'Transférez de l\'argent en un clic ! à l\'international avec votre paylink.',
    description_en: 'Send money in one tap, even internationally, with your Paylink.',
    show: true,
    view: 'other',
    type: 'Finance',
  },
  {
    id: 41,
    name: 'Vibe Burok',
    name_en: 'Burok Vibes',
    logo: getAssetUrl('Files/Logos/VibeBurokLogo.png'),
    banner: getAssetUrl('Files/Banners/vibebanner2.webp'),
    description: 'Votre musique, votre vibe. Écoutez vos titres préférés sur Burok.',
    description_en: 'Your music, your vibe. Listen to your favorite tracks on Burok.',
    show: true,
    view: 'other',
    type: 'Autres',
  },
  {
    id: 42,
    name: 'Spotify',
    name_en: 'Spotify',
    logo: getAssetUrl('Files/Logos/Spotify%20App%20Logo.png'),
    banner: getAssetUrl('Files/Banners/spotifybanner.webp'),
    description: 'Écoutez des millions de titres et podcasts sur Spotify. Music for everyone.',
    description_en: 'Listen to millions of songs and podcasts on Spotify. Music for everyone.',
    show: true,
    view: 'other',
    type: 'Autres',
  },
  {
    id: 43,
    name: 'Yango',
    name_en: null,
    logo: getAssetUrl('Files/Logos/YANGOLOGO.png'),
    banner: getAssetUrl('Files/Banners/yangobanner2.webp'),
    description: 'Réservez un taxi rapidement et en toute sécurité avec Yango. Des trajets confortables à petits prix.',
    description_en: null,
    show: true,
    view: 'other',
    type: 'Transport',
  },
];